export default function DSA_Kruskals() {
  return <div>DSA_Kruskals Component</div>;
}
